const THRESHOLD = 116;
export const isElementLowerThanThreshold = (refererElement = null, threshold = THRESHOLD) => {
  try {
    if (refererElement === null) throw 'All params for hideElementMoreThresholdHeight are mandatory';
    const refererElementHeight = refererElement ? refererElement.scrollHeight : 0;
    return refererElementHeight <= threshold;
  } catch (e) {
    throw new Error(`error : ${e}`);
  }
};